import { formatNumber } from "shared/locale/format";

import Button from "features/components/Button";
import Skeleton from "features/ui/Skeleton";

interface ToggleButtonProps {
  count?: number;
  label: string;
  isActive: boolean;
  onClick: () => void;
  isLoading?: boolean;
}

const ToggleButton = ({
  count,
  label,
  isActive,
  onClick,
  isLoading,
}: ToggleButtonProps) => (
  <Button
    variant={isActive ? "contained" : "text"}
    color={isActive ? "tertiary" : "primary"}
    onClick={onClick}
    sx={{ maxHeight: 30, fontSize: 13 }}
    disabled={isLoading}
  >
    {isLoading ? (
      <Skeleton width={140} height={16} />
    ) : (
      <>
        <b>{formatNumber(count ?? 0)}</b> {label}
      </>
    )}
  </Button>
);

export default ToggleButton;
